import { Modal, Button } from 'react-bootstrap';

interface ReactivatePlanModalProps {
    show: boolean;
    onHide: () => void;
    onActivateNextCycle: () => void;
}

export default function ReactivatePlanModal({
    show,
    onHide,
    onActivateNextCycle,
}: ReactivatePlanModalProps) {
    return (
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Activate Plan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Plan will be billed at the start of the <strong> next billing cycle.</strong>
                </p>
                <div className="d-flex flex-column gap-3 mt-3">
                    <Button variant="primary" onClick={onActivateNextCycle}>
                        Start at Next Billing Cycle
                    </Button>
                    <Button variant="outline-secondary" onClick={onHide}>
                        Go Back
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
